// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table[data-v-d5d2737c]{border-collapse:collapse}table[data-v-d5d2737c],td[data-v-d5d2737c],th[data-v-d5d2737c]{border:.5px solid #000}thead[data-v-d5d2737c]{display:table-row-group}tr td[data-v-d5d2737c]{page-break-inside:avoid}.no-border[data-v-d5d2737c]{border:none!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
